import axios from "axios";

import { ApiResponse } from "../../models/api.response.model";
import { Company } from "../../models/company.model";
import { Error } from "../../models/error.model";
import { Template } from "../../models/template.model";
import { InvoiceQrTemplate } from "../../models/invoice.qr.template.model";
import { authToken } from "../../scripts/authentication.script";
import { Design } from "../../models/settings.designs.model";

export class DesignDA {
  static apiResponse: ApiResponse;

  public static async getTemplates(id_company: string): Promise<ApiResponse> {
    if (process.env.REACT_APP_ENVIRONMENT === "development") {
      let companies: Company[] | null = null;
      let templates: Template[] | null = null;
      let error: Error | null = null;

      await axios
        .get("../../../../../database/companies.data.json")
        .then((response) => {
          companies = response.data.companies;
        })
        .catch((error) => {
          alert(error);
        });
      await axios
        .get("../../../../../database/templates.data.json")
        .then((response) => {
          templates = response.data;
        })
        .catch((error) => {
          alert(error);
        });
      await axios
        .get("../../../../../database/error.data.json")
        .then((response) => {
          error = response.data;
        })
        .catch((error) => {
          alert(error);
        });

      if (companies!.some((item) => item.id === id_company)) {
        this.apiResponse = {
          status: 200,
          message: "Success",
          data: templates,
        };
      } else {
        this.apiResponse = {
          status: 400,
          message: "Bad request",
          data: error,
        };
      }
    } else {
      let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/templates`;

      let config: any = {
        headers: { Authorization: authToken() },
      };

      await axios
        .get(url, config)
        .then((response) => {
          this.apiResponse = {
            status: response.status,
            message: response.statusText,
            data: response.data?.data ?? response.data,
          };
        })
        .catch((error) => {
          this.apiResponse = {
            status: error.response?.status || 500,
            message: error.response?.statusText || "Error",
            data: error.response?.data?.error ?? error.response?.data ?? { code: "NETWORK_ERROR", message: error.message },
          };
        });
    }

    return this.apiResponse;
  }

  public static async getQrTemplate(id_company: string, id_invoice: string): Promise<ApiResponse> {
    if (process.env.REACT_APP_ENVIRONMENT === "development") {
      let invoiceQrTemplate: any | InvoiceQrTemplate = null;
      let error: Error | null = null;

      await axios
        .get("../../../../../database/qr.template.data.json")
        .then((response) => {
          invoiceQrTemplate = response.data;
        })
        .catch((error) => {
          alert(error);
        });
      await axios
        .get("../../../../../database/error.data.json")
        .then((response) => {
          error = response.data;
        })
        .catch((error) => {
          alert(error);
        });

      if (invoiceQrTemplate.id_invoice === id_invoice) {
        this.apiResponse = {
          status: 200,
          message: "Success",
          data: invoiceQrTemplate,
        };
      } else {
        this.apiResponse = {
          status: 400,
          message: "Bad request",
          data: error,
        };
      }
    } else {
      let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/invoices/${id_invoice}/qr`;

      let config: any = {
        headers: { Authorization: authToken() },
      };

      await axios
        .get(url, config)
        .then((response) => {
          this.apiResponse = {
            status: response.status,
            message: response.statusText,
            data: response.data?.data ?? response.data,
          };
        })
        .catch((error) => {
          this.apiResponse = {
            status: error.response?.status || 500,
            message: error.response?.statusText || "Error",
            data: error.response?.data?.error ?? error.response?.data ?? { code: "NETWORK_ERROR", message: error.message },
          };
        });
    }

    return this.apiResponse;
  }

  public static async getDesigns(id_company: string): Promise<ApiResponse> {
    if (process.env.REACT_APP_ENVIRONMENT === "development") {
      let designs: Design[] | null = null;
      let error: Error | null = null;

      await axios
        .get("../../../../../database/settings.designs.data.json")
        .then((response) => {
          designs = response.data;
        })
        .catch((error) => {
          alert(error);
        });
      await axios
        .get("../../../../../database/error.data.json")
        .then((response) => {
          error = response.data;
        })
        .catch((error) => {
          alert(error);
        });

      if (designs) {
        this.apiResponse = {
          status: 200,
          message: "Success",
          data: designs,
        };
      } else {
        this.apiResponse = {
          status: 400,
          message: "Bad request",
          data: error,
        };
      }
    } else {
      let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/designs`;

      let config: any = {
        headers: { Authorization: authToken() },
      };

      await axios
        .get(url, config)
        .then((response) => {
          this.apiResponse = {
            status: response.status,
            message: response.statusText,
            data: response.data ?? [],
          };
        })
        .catch((error) => {
          this.apiResponse = {
            status: error.response?.status || 500,
            message: error.response?.statusText || "Error",
            data: error.response?.data?.error ?? error.response?.data ?? { code: "NETWORK_ERROR", message: error.message },
          };
        });
    }

    return this.apiResponse;
  }

  public static async postPurchase(id_company: string, id_design: string): Promise<ApiResponse> {
    if (process.env.REACT_APP_ENVIRONMENT === "development") {
      let designs: Design[] | null = null;
      let error: Error | null = null;

      await axios
        .get("../../../../../database/settings.designs.data.json")
        .then((response) => {
          designs = response.data;
        })
        .catch((error) => {
          alert(error);
        });
      await axios
        .get("../../../../../database/error.data.json")
        .then((response) => {
          error = response.data;
        })
        .catch((error) => {
          alert(error);
        });

      if (designs) {
        this.apiResponse = {
          status: 200,
          message: "Success",
          data: designs,
        };
      } else {
        this.apiResponse = {
          status: 400,
          message: "Bad request",
          data: error,
        };
      }
    } else {
      let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/designs/${id_design}/purchase`;

      let config: any = {
        headers: { Authorization: authToken() },
      };

      await axios
        .get(url, config)
        .then((response) => {
          this.apiResponse = {
            status: response.status,
            message: response.statusText,
            data: response.data?.data ?? [],
          };
        })
        .catch((error) => {
          this.apiResponse = {
            status: error.response?.status || 500,
            message: error.response?.statusText || "Error",
            data: error.response?.data?.error ?? error.response?.data ?? { code: "NETWORK_ERROR", message: error.message },
          };
        });
    }

    return this.apiResponse;
  }

  public static async putSetCurrent(id_company: string, id_design: string): Promise<ApiResponse> {
    if (process.env.REACT_APP_ENVIRONMENT === "development") {
      let designs: Design[] | null = null;
      let error: Error | null = null;

      await axios
        .get("../../../../../database/settings.designs.data.json")
        .then((response) => {
          designs = response.data;
        })
        .catch((error) => {
          alert(error);
        });
      await axios
        .get("../../../../../database/error.data.json")
        .then((response) => {
          error = response.data;
        })
        .catch((error) => {
          alert(error);
        });

      if (designs) {
        this.apiResponse = {
          status: 200,
          message: "Success",
          data: designs,
        };
      } else {
        this.apiResponse = {
          status: 400,
          message: "Bad request",
          data: error,
        };
      }
    } else {
      let url: string = `${process.env.REACT_APP_PORT_ADMIN}/designs/${id_design}/set-current`;

      let config: any = {
        headers: { Authorization: authToken() },
      };

      await axios
        .get(url, config)
        .then((response) => {
          this.apiResponse = {
            status: response.status,
            message: response.statusText,
            data: response.data?.data ?? [],
          };
        })
        .catch((error) => {
          this.apiResponse = {
            status: error.response?.status || 500,
            message: error.response?.statusText || "Error",
            data: error.response?.data?.error ?? error.response?.data ?? { code: "NETWORK_ERROR", message: error.message },
          };
        });
    }

    return this.apiResponse;
  }
}
